import { isFeatureEnabledInConfig } from "./feature-utils"
import { useConfigQuery } from "./use-config-query"

/**
 * Hook to check if a feature is available and enabled for the current user
 * @param featureId The feature ID to check (e.g., "scholar")
 * @returns boolean indicating if the feature is available
 */
export function useFeatureEnabled(featureId: string): boolean {
  const { data: config } = useConfigQuery()
  return isFeatureEnabledInConfig(config?.features, featureId)
}
